import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { Outlet } from 'react-router-dom';
import { useRecoilValue } from 'recoil';

import { FloatingActionButtons } from 'Components/FloatingActionButtons';
import { Loader } from 'Components/Loader';
// import { Header } from 'Components/Header';
import { constants } from 'lib/constants';
import { initPlugState } from 'lib/recoil/atoms';

export const Layout = () => {
	const { isLoading } = useRecoilValue(initPlugState);

	return (
		<>
			{/* <Header /> */}
			<Container
				maxWidth='xl'
				// disableGutters
				sx={{
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					marginBottom: constants.SPACING,
					marginTop: 6,
					'& > *:not(:last-child)': {
						marginBottom: constants.SPACING
					}
				}}
			>
				<Outlet />
			</Container>
			<Loader isLoading={isLoading}>
				<Typography variant='h6' fontWeight='bold'>
					Setting up your wallet!
				</Typography>
			</Loader>
			<FloatingActionButtons />
		</>
	);
};
